import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useFolders(clubId: string | null, parentId?: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.folders(clubId ?? "", parentId),
		queryFn: () => clubApi.folders.list(clubId!, parentId),
		enabled: !!clubId,
	});
}

export function useCreateFolder(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: unknown) => clubApi.folders.create(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "folders"],
			}),
	});
}

export function useDeleteFolder(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (folderId: string) => clubApi.folders.delete(clubId, folderId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "folders"],
			}),
	});
}

export function useDocuments(clubId: string | null, folderId?: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.documents(clubId ?? "", folderId),
		queryFn: () => clubApi.documents.list(clubId!, folderId),
		enabled: !!clubId,
	});
}

export function useUploadDocument(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ file, folderId }: { file: File; folderId?: string }) =>
			clubApi.documents.upload(clubId, file, folderId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "documents"],
			}),
	});
}

export function useDeleteDocument(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (docId: string) => clubApi.documents.delete(clubId, docId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "documents"],
			}),
	});
}
